// extracted by mini-css-extract-plugin
export default {"container":"profile-form-container_container__4jHJW","links":"profile-form-container_links__Mqtze"};